import MpTextFieldMultiple from "src/components/MpTextFieldMultiple";
import { useTranslation } from "src/hooks";
import { FilterFieldsKeys } from "../../../../types/FilterFields";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function WalletAddressTextField({
  value,
  onChange,
  count,
}: {
  value: string;
  onChange: (value: string) => void;
  count: number;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  return (
    <MpTextFieldMultiple
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label={tc("phInputField", {
        fieldName: t(FilterFieldsKeys.WalletAddress),
      })}
      count={count}
    />
  );
}

export default WalletAddressTextField;
